const manuscriptTypes = [
  "REVIEW",
  "ORIGINAL RESEARCH",
  "COMMUNICATION",
  "EDITORIAL",
  "POLICY HIGHLIGHT",
  "POLICY BRIEF",
];

const manuscriptStatuses = [
  "NEW",
  "RESUBMISSION REQUESTED",
  "FLAGGED",
  "EDITOR ASSIGNED",
  "REVIEWER INVITED",
  "REVIEWER ASSIGNED",
  "UNDER REVIEW",
  "DECISION IN PROGRESS",
  "MINOR REVISION REQUIRED",
  "MAJOR REVISION REQUIRED",
  "HAS DECISION",
  "PUBLISHED",
];

const manuscriptStatus = {
  new: "NEW",
  resubmissionRequested: "RESUBMISSION REQUESTED",
  flagged: "FLAGGED",
  editorAssigned: "EDITOR ASSIGNED",
  reviewerInvited: "REVIEWER INVITED",
  reviewerAssigned: "REVIEWER ASSIGNED",
  underReview: "UNDER REVIEW",
  decisionInProgress: "DECISION IN PROGRESS",
  minorRevision: "MINOR REVISION REQUIRED",
  majorRevision: "MAJOR REVISION REQUIRED",
  decided: "HAS DECISION",
  published: "PUBLISHED",
};

const manuscriptStatusesHavingDecision = [
  "FLAGGED",
  "MINOR REVISION REQUIRED",
  "MAJOR REVISION REQUIRED",
  "HAS DECISION",
];

const manuscriptDecisions = ["ACCEPTED", "REJECTED", "RESUBMIT"];

const manuscriptAuthor = {
  title: null,
  firstName: null,
  lastName: null,
  institution: null,
  department: null,
  specialization: null,
  email: null,
  phone: null,
  isPrincipal: false,
  isCorresponding: false,
};

export {
  manuscriptTypes,
  manuscriptStatuses,
  manuscriptStatusesHavingDecision,
  manuscriptAuthor,
  manuscriptDecisions,
  manuscriptStatus,
};
